'use strict';

class mFormSubmitButtons extends HTMLDivElement {
    constructor() {
        super();
        this.sourceName = this.dataset.sourcename;
        if (this.sourceName) {
            this.formValid = this.querySelectorAll('[data-components-' + this.sourceName + '-valid]');
            this.formValidation = this.querySelectorAll('[data-components-' + this.sourceName + '-triggerValidation]');
        }
        this.editableFields = this.querySelectorAll('[is="m-editable-field"]');
        this.btnsUpdate = this.querySelectorAll('.cta-update');
        this.formMessageElem = document.getElementById(`${this.sourceName}-form-message`);

        this.onSubmitClicked = this.onSubmitClicked.bind(this);
    }

    connectedCallback() {
        if (this.sourceName) {
            if (this.formValidation && this.formValidation.length > 0) {
                this.formValidation.forEach((elem) => {
                    elem.addEventListener('click', this.onSubmitClicked);
                });
            }
        }
    }

    onSubmitClicked(e) {
        // move form message under the clicked submit button
        if (this.formMessageElem && e.target) {
            this.formMessageElem.innerHTML = '';
            e.target.after(this.formMessageElem);
        }

        this.formValid[0].dispatchEvent(new Event('click'));
        this.displayFieldsWithError();
    }

    displayFieldsWithError() {
        this.editableFields.forEach(editableField => {
            const error = editableField.querySelector('.error');
            if (error) {
                editableField.displayInput();
            }
        });
    }
}

customElements.define('m-form-submit-buttons', mFormSubmitButtons, {
    extends: 'div'
});
